module.exports = __webpack_public_path__ + "img/cover_pressalit_4.6cc7ced6.jpg";